<template>
<!-- 售后服务-关于我们 -->
    <div class="aboutUs">
        <img src="../assets/icon_logo@2x.png" alt="jiajiamingLOGO">
        <p>
            北京 方和 科技有限责任公司，创立于1998年北京大学百年华诞校庆期间；是中关村国际孵化园内，国家级高新技术企业；20多年呕心沥血自主研发眼健康，近视防控“专心、专注、专业”，精益求精。
        </p>
        <p>
            首创——脉冲气体分子，全自动化 健康眼睛，防控青少年近视 、阻止延缓近视加深、彻底消除眼疲劳；原生态，生物节奏，自然疗法；用世界上至轻、至柔软物质——气体分子,全自动化 运动揉压人类最娇嫩、最宝贵器官眼睛；原理简朴、良效奇特。
        </p>
        <p>
            加加明“三位一体”综合近视防治理论体系方法，可使孩子们眼睛：不疲劳、不近视、缓加深。
        </p>
        <p>
            ——中国 好眼睛，加加明JJM-II，高端医疗 智能科技。国家发明专利技术应用，二类医疗器械，眼科医学新技术突破。
        </p>
        <p>
            【气体特殊性：是世界上至轻、至软物质；均匀柔和，等气压、等面积 】
        </p>
        <p>
            “加加明”近视眼防治仪，在中国著名眼科专业医院19家配镜中心店推广销售（没有第二家）；北京同仁医院、北京大学第三医院、北京大学人民医院、首都儿研所、民众眼科医院、茗视光眼科、美和眼科医院均推广销售。
        </p>
        <p>
            北京朝阳区实验小学等近20多所学校，由教委出资，建立《爱眼工作室》购买加加明仪器，免费提供学生使用，受到家长和孩子欢迎！
        </p>
        <!-- <p>联系方式</p> -->
        <p>1、咨询电话:010-82057855</p>
        <p>2、官 网 : www.jjmcn.com</p>
        <p>3、地 址:北京市海淀区光耀东方大厦N座</p>
        <!-- <p>4、联系地址:北京市海淀区苏州街人民大学北路33号院2号楼沁园公寓2206室</p> -->
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.aboutUs {
    margin: 28px;
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.aboutUs img {
    width: 154px;
    display: block;
    margin: 14px auto 50px;
}
.aboutUs p {
    font-size: 34px;
    line-height: 60px;
    text-indent: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue